export default [
    {
        path: '/pages/coupon/shopCouponManage',
        name: '/pages/coupon/shopCouponManage',
        meta: { title: '优惠券' },
        component: () => import('@/views/coupon/shopCouponManage.vue')
    },
    {
        path: '/pages/coupon/userCouponManage',
        name: '/pages/coupon/userCouponManage',
        meta: { title: '用户优惠券' },
        component: () => import('@/views/coupon/userCouponManage.vue')
    },
    {
        path: '/pages/coupon/couponGiveLogManage',
        name: '/pages/coupon/couponGiveLogManage',
        meta: { title: '赠送记录' },
        component: () => import('@/views/coupon/couponGiveLogManage.vue')
    },
    {
        path: '/pages/coupon/couponReceiveLogManage',
        name: '/pages/coupon/couponReceiveLogManage',
        meta: { title: '领取记录' },
        component: () => import('@/views/coupon/couponReceiveLogManage.vue')
    },
    {
        path: '/pages/coupon/couponUseLogManage',
        name: '/pages/coupon/couponUseLogManage',
        meta: { title: '使用记录' },
        component: () => import('@/views/coupon/couponUseLogManage.vue')
    },
    {
        path: '/views/goods/staffCollectedProduct',
        name: '/views/goods/staffCollectedProduct',
        meta: { title: '收藏商品' },
        component: () => import('@/views/goods/staffCollectedProduct.vue')
    }
]

